import React from 'react';
import { Fragment } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import verified from '../images/verified-blue.svg';

export default class FollowDisplayName extends React.Component {
  static propTypes = {
    user: PropTypes.object, //name, slug, hasActiveSubscription
  }

  render() {
    return (
      <Link to={ `/people/${ this.props.user.get('slug') }` } className='follow-name link-with-no-border'>
        { this.renderName() }
      </Link>
    );
  }

  renderName() {
    const name = this.props.user.get('name') || this.props.user.get('slug');
    if (this.props.user.get('hasActiveSubscription')) {
      return (
        <Fragment>
          { name }&nbsp;
          <span className='verified-mark-15-inline'>
            <img src={verified} alt='Verified and Unlimited' />
          </span>
        </Fragment>
      )
    } else {
      return name;
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/follow_display_name.jsx